import { Component, computed, input } from '@angular/core';
import { ParsedErrorResponse } from '../../core/models/parsed-error-response.model';
import { IconComponent } from '../icons/icon.component';
import { IconNameType } from '../icons/icon-name-type.enum';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'cwo-parse-errors-message',
  standalone: true,
  imports: [IconComponent, TranslocoPipe],
  templateUrl: './parse-errors-message.component.html',
  styleUrl: './parse-errors-message.component.scss'
})
export class ParseErrorsMessageComponent {
  parsedErrors = input.required<ParsedErrorResponse>();

  iconNameType = IconNameType;
  
  errors = computed(() => {
    if(this.parsedErrors().errors){
      return Object.keys(this.parsedErrors().errors!).flatMap(key => this.parsedErrors().errors![key]);
    } else {
      return undefined;
    }
  })

}
